module.exports = __webpack_public_path__ + "img/activity_indicator.7fc09f7a.gif";